import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import isEmpty from "lodash/isEmpty";
import React, { Component } from "react";

import Button from "../../../forms/custom/Button";

const styles = () => ({
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    paddingRight: "26px",
    paddingTop: "24px",
  },
  errorMessage: {
    display: "flex",
    alignItems: "center",
    padding: "0 24px",
  },
  submitButtonContainer: {
    position: "relative",
  },
  buttonProgress: {
    position: "absolute",
    top: "20%",
    left: "50%",
    marginRight: "-12px",
    marginLeft: "-12px",
    color: "#008dae",
  },
});

class RegistrationFormFooter extends Component {
  constructor(props) {
    super(props);

    this.errorMessageRef = React.createRef();
    this.state = { errorMessage: null };
    this.userErrorMessage = "Please review the fields highlighted in red.";
  }

  componentDidUpdate({ isSubmitting: prevSubmitting }) {
    const { isSubmitting, errors } = this.props;

    if (prevSubmitting && !isSubmitting && !isEmpty(errors)) {
      this.setState(
        { errorMessage: errors.internalError || this.userErrorMessage },
        this.animateErrorMessage
      );
    } else if (this.state.errorMessage && isEmpty(errors)) {
      this.setState({ errorMessage: null });
    }
  }

  animateErrorMessage = () => {
    const messageEl = this.errorMessageRef.current;

    const handleAnimationEnd = () => {
      messageEl.classList.remove("fadeIn");
      messageEl.removeEventListener("animationend", this.handleAnimationEnd);
    };

    handleAnimationEnd();
    messageEl.addEventListener("animationend", handleAnimationEnd);
    messageEl.classList.add("fadeIn");
  };

  render() {
    const { classes, talk } = this.props;
    const { errorMessage } = this.state;

    return (
      <div className={classes.container}>
        <div
          ref={this.errorMessageRef}
          className={classnames("red", classes.errorMessage, "animated")}
        >
          {errorMessage}
        </div>
        <div className={this.props.classes.submitButtonContainer}>
          <Button
            color={talk ? "cardinal" : "blue"}
            variant="primary"
            onClick={this.props.handleSubmit}
            disabled={this.props.isSubmitting}
            data-cy="footer-register-button"
          >
            Begin
          </Button>
          {this.props.isSubmitting && (
            <CircularProgress
              size={24}
              className={this.props.classes.buttonProgress}
            />
          )}
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(RegistrationFormFooter);
